import { render } from "./Inicio.vue?vue&type=template&id=bd7d55de&class=mainInicio"
const script = {}

import "./Inicio.vue?vue&type=style&index=0&id=bd7d55de&lang=scss"

import exportComponent from "C:\\Users\\Fabiano\\OneDrive\\Área de Trabalho\\Project\\andremudancasemgeral\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__